// extracted by mini-css-extract-plugin
module.exports = {"pageMain":"styles_pageMain__WhaaP","container":"styles_container__wR0Zn"};